<template>
  <div class="account-feedback">
    <el-row
      type="flex"
      justify="center">
      <el-col
        :xl="{span: 10}"
        :lg="{span: 12}"
        :md="{span: 16}"
        :sm="{span: 18}"
        :xs="{span: 18}"
        class="t-c">
        <h4>We would love to hear from you.</h4>
        <p>Your feedback...</p>
        <el-input
          v-model="feedback"
          :autofocus="true"
          :rows="6"
          :maxlength="200"
          type="textarea"
        />
        <el-button
          :loading="submitting_feedback"
          type="primary"
          class="m-t"
          @click="submitFeedback">Submit</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as log from 'loglevel';
import UserService from '../../services/User';
import PageMixin from '../../shared/pageMixin';

export default {
  mixins: [PageMixin],
  data() {
    return {
      pageName: 'Feedback',
      user_service: new UserService(),
      feedback: '',
      is_logged_in: this.$store.getters.loggedIn,
      submitting_feedback: false,
    };
  },
  mounted() {
    window.eventBus.$emit('settings-tab-change', 'feedback');
  },
  beforeMount() {
    if (!this.is_logged_in) {
      this.$router.push('/listen');
    }
  },
  methods: {
    submitFeedback() {
      if (this.isNullOrWhiteSpace(this.feedback)) {
        this.showErrorMsg('Please provide some feedback first!');
        return;
      }
      if (this.feedback.length && this.feedback.trim().length < 10) {
        this.showErrorMsg('Your feedback is very short. Please write some more.');
        return;
      }
      this.submitting_feedback = true;
      const { email } = this.$store.getters.user;
      this.user_service.sendLuminaryFeedback(this.feedback, email)
        .then((res) => {
          if (res && res.success) this.showSuccessMsg('Thank you for your feedback.');
          this.submitting_feedback = false;
        })
        .catch((err) => {
          this.showErrorMsg(err.obj.error);
          log.info(err.message);
        })
        .then(() => {
          this.submitting_feedback = false;
          this.feedback = '';
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/variables.scss";
.account-feedback {
  padding: 40px 0 50px;

  h4 {
    margin: 50px 0 0 0 !important;
    font-family: "ITC Clearface";
    font-size: 32px;
    letter-spacing: -1px;
    line-height: 36px;
  }

  p {
    color: $black;
    font-size: 16px;
    line-height: 20px;
    margin: 25px 0 4px 0;
  }
  .el-button {
    padding:15px 35px;
    span {
      font-size: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// app/src/pages/account/Feedback.vue